import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";

import sortBy from "lodash/sortBy";
import map from "lodash/map";
import sumBy from "lodash/sumBy";
import find from "lodash/find";

class HighestOpportunityAudience extends AcquireWebComponent {
  render() {
    const {
      type,
      data,
      systems,
      total,
      orderType,
      topCount,
      printMode,
    } = this.props;
    const sortedData =
      orderType === "index"
        ? sortBy(data, d => {
            return d.segmentIndex;
          })
            .reverse()
            .slice(0, topCount === 0 ? data.length : topCount)
        : sortBy(data, d => {
            return d.householdVisitors / total;
          })
            .reverse()
            .slice(0, topCount === 0 ? data.length : topCount);
    const sumIndex = sumBy(sortedData, d => {
      return d.segmentIndex;
    });
    const sumHouseholdVisitors = sumBy(sortedData, d => {
      return d.householdVisitors;
    });
    const sumHouseholdPercentage = sumBy(sortedData, d => {
      return d.householdPercentage;
    });

    let reportType = "";
    const system = find(systems, s => {
      return parseInt(s.id, 10) === parseInt(type, 10);
    });
    if (system) reportType = system.name;

    const showIndex = orderType === "index" || printMode === true;

    return (
      <div
        className="light-grey-border pt-20 pl-20 pr-20"
        style={{ fontSize: "16px" }}
      >
        <div>
          <h1 className="no-margin">
            <strong>Highest Opportunity Audiences</strong>
          </h1>
        </div>
        <div
          style={{ padding: "20px", background: "#D9DBDD", marginTop: "20px" }}
        >
          {reportType.split(" ").length > 1 &&
          reportType.split(" ")[0] !== "Purple" ? (
            <strong>
              {reportType.split(" ")[0]}
              <i className="symbol symbol-tm" /> {reportType.split(" ")[1]}{" "}
              Segments
            </strong>
          ) : (
            <strong>
              {reportType} <i className="symbol symbol-tm" /> {" Segments"}
            </strong>
          )}
        </div>
        <div
          style={{ padding: "20px", background: "#F5F5F5", display: "flex" }}
        >
          <div
            style={{
              width:
                reportType === "Metro Target" || reportType === "VOLKSeg"
                  ? "25%"
                  : "10%",
              paddingTop: "10px",
            }}
          >
            <strong>Segment</strong>
          </div>
          {reportType !== "Metro Target" && reportType !== "VOLKSeg" && (
            <div
              style={{
                width: showIndex ? "35%" : "40%",
                paddingTop: "10px",
              }}
            >
              <strong>Segment Name</strong>
            </div>
          )}
          <div
            style={{
              width:
                reportType === "Metro Target" || reportType === "VOLKSeg"
                  ? showIndex
                    ? "30%"
                    : "40%"
                  : "25%",
            }}
          >
            <strong>
              Segment Percent of
              <br /> U.S. Households
            </strong>
          </div>
          <div
            style={{
              width: showIndex ? "30%" : "auto",
            }}
          >
            <strong>
              Percent of <br /> Household Visitors
            </strong>
          </div>
          {showIndex && (
            <div>
              <strong>Index</strong>
            </div>
          )}
        </div>
        <div
          className="hightest-audience-list"
          style={
            topCount === 0 && sortedData.length >= 10
              ? {
                  height: "650px",
                  overflowY: "auto",
                }
              : {
                  height: "auto",
                }
          }
        >
          {sortedData && sortedData.length > 0 ? (
            map(sortedData, d => {
              return (
                <div
                  key={"highest-row-" + d.segmentCode}
                  style={{ padding: "20px", display: "flex" }}
                >
                  <div
                    key={"div-segment-code-" + d.segmentCode}
                    style={{
                      width:
                        reportType === "Metro Target" ||
                        reportType === "VOLKSeg"
                          ? "25%"
                          : "10%",
                    }}
                  >
                    {d.segmentCode}
                  </div>
                  {reportType !== "Metro Target" && reportType !== "VOLKSeg" && (
                    <div
                      key={"div-segment-name-" + d.segmentCode}
                      style={{
                        width: showIndex ? "35%" : "40%",
                      }}
                    >
                      {d.segmentName}
                    </div>
                  )}
                  <div
                    key={"div-segment-place-holder-" + d.segmentCode}
                    style={{
                      width:
                        reportType === "Metro Target" ||
                        reportType === "VOLKSeg"
                          ? showIndex
                            ? "30%"
                            : "40%"
                          : "25%",
                    }}
                  >
                    {d.householdPercentage.toLocaleString(undefined, {
                      style: "percent",
                      minimumFractionDigits: 2,
                    })}{" "}
                  </div>
                  <div
                    key={"div-segment-percentage-" + d.segmentCode}
                    style={{
                      width: showIndex ? "30%" : "auto",
                    }}
                  >
                    {(d.householdVisitors / this.props.total).toLocaleString(
                      undefined,
                      {
                        style: "percent",
                        minimumFractionDigits: 2,
                      },
                    )}
                  </div>
                  {showIndex && (
                    <div key={"div-segment-index-" + d.segmentCode}>
                      {d.segmentIndex}
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <div
              className="light-grey-border text-center p-10 mb-20"
              id="contact-div"
              style={{ color: "#DD0000" }}
            >
              No data to display
            </div>
          )}
        </div>
        <div
          style={{
            padding:
              topCount === 0 && sortedData.length >= 10
                ? "10px 30px 10px 20px"
                : "10px 20px",
            marginBottom: "20px",
            background: "#F5F5F5",
            display: sortedData && sortedData.length > 0 ? "flex" : "none",
          }}
        >
          <div
            style={{
              width:
                reportType === "Metro Target" || reportType === "VOLKSeg"
                  ? "25%"
                  : "10%",
            }}
          >
            <strong>Total</strong>
          </div>
          {reportType !== "Metro Target" && reportType !== "VOLKSeg" && (
            <div
              style={{
                width: showIndex ? "35%" : "40%",
              }}
            >
              <strong>&nbsp;</strong>
            </div>
          )}
          <div
            style={{
              width:
                reportType === "Metro Target" || reportType === "VOLKSeg"
                  ? showIndex
                    ? "30%"
                    : "40%"
                  : "25%",
            }}
          >
            <strong>
              {sumHouseholdPercentage.toLocaleString(undefined, {
                style: "percent",
                minimumFractionDigits: 2,
              })}
            </strong>
          </div>
          <div
            style={{
              width: showIndex ? "30%" : "auto",
            }}
          >
            <strong>
              {(sumHouseholdVisitors / this.props.total).toLocaleString(
                undefined,
                {
                  style: "percent",
                  minimumFractionDigits: 2,
                },
              )}
            </strong>
          </div>
          {showIndex && (
            <div>
              <strong>
                {parseInt(
                  (sumHouseholdVisitors /
                    this.props.total /
                    sumHouseholdPercentage) *
                    100,
                  10,
                )}
              </strong>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default HighestOpportunityAudience;



// WEBPACK FOOTER //
// ./src/components/Insights/distribution/HighestOpportunityAudience.js